export const googleSlideInputDataSet = { cy: 'GoogleSlides-input' };
export const continueFromGoogleSlides = { cy: 'GoogleSlides-continue-button' };
